import React from 'react'
import API from '../../../API'
import styled from 'styled-components';
import { P1, Modal } from 'pfm-ui-components'
import { routes } from '../../../config/routes';
import { withRouter, NextRouter} from 'next/router'


interface WithRouterProps {
    router: NextRouter;
}

interface MyComponentProps extends WithRouterProps {}

interface MyAppState {
    hasError: boolean;
}

class ErrorBoundary extends React.Component<MyComponentProps,MyAppState> {
    constructor(props) {
      super(props)
  
      // Define a state variable to track whether is an error or not
      this.state = { hasError: false }
    }
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI
  
      return { hasError: true }
    }
    componentDidCatch(error, errorInfo) {
      // You can use your own error logging service here
      const errorLog = {error : {message:error.message, trace:errorInfo.componentStack, path: this.props.router.pathname, stack:error.stack}};
      API.scheme.logUnhandledError(errorLog).then(() => {
        console.log("Error logged");
      })
      .catch((err) => {
        console.log("Error logging failed");
      })
    }
    render() {
      // Check if the error is thrown
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return (
          <StyledAlertModal
          className="alert-modal"
          wrapperClassname="alert-modal-wrapper"
          contentClassname="alert-modal-content"
          onClose={() => {
            this.props.router.push(routes.MUTUAL_FUND.url);
            this.setState({ hasError: false });
         }}
          mode="alert"
          showHeader={false}
        >
          <StyledP1>{"Sorry, something went wrong. Please try again."}</StyledP1>
        </StyledAlertModal>
        //   <div>
        //     <h2>Oops, there is an error!</h2>
        //     <button
        //       type="button"
        //       onClick={() => this.setState({ hasError: false })}
        //     >
        //       Try again?
        //     </button>
        //   </div>
        )
      }
  
      // Return children components in case of no error
  
      return this.props.children
    }
  }
  

  const StyledP1 = styled(P1)`
  color: #6d6e71;
`;

export const StyledAlertModal = styled(Modal)`
  .alert-modal-wrapper {
    display: flex;
  }

  .alert-modal-content {
    align-self: center;
    margin: 0 auto;
    left: 0;
  }
`;

export default withRouter(ErrorBoundary);